import { render } from "./QuestDialog5.vue?vue&type=template&id=304cd2d8"
import script from "./QuestDialog5.vue?vue&type=script&lang=js"
export * from "./QuestDialog5.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/questDialogs/QuestDialog5.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "304cd2d8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('304cd2d8', __exports__)) {
    api.reload('304cd2d8', __exports__)
  }
  
  module.hot.accept("./QuestDialog5.vue?vue&type=template&id=304cd2d8", () => {
    api.rerender('304cd2d8', render)
  })

}


export default __exports__